export const RENTERS_LANDING_PAGE = 'renters_landing_page';
export const PET_LANDING_PAGE = 'pet_landing_page';
export const HOMEOWNERS_LANDING_PAGE = 'homeowners_landing_page';
export const LEMONADE_PAGE = 'lemonade_homepage';
export const CAR_LANDING_PAGE = 'car_landing_page';
export const GIVEBACK_LANDING_PAGE = 'giveback_landing_page';
export const FAQ_LANDING_PAGE = 'faq_landing_page';
export const CLAIMS_LANDING_PAGE = 'claims_landing_page';
export const LIFE_LANDING_PAGE = 'life_landing_page';
export const PET_CUSTOMIZABLE_INSURANCE_PAGE_NAME = 'pet landing page +45';
export const FSD_LANDING_PAGE = 'fsd_landing_page';

export const ADA_AB_TEST_PAGES = {
  car: CAR_LANDING_PAGE,
  fsd: FSD_LANDING_PAGE,
  renters: RENTERS_LANDING_PAGE,
  pet: PET_LANDING_PAGE,
  homeowners: HOMEOWNERS_LANDING_PAGE,
  life: LIFE_LANDING_PAGE,
  giveback: GIVEBACK_LANDING_PAGE,
  faq: FAQ_LANDING_PAGE,
  claims: CLAIMS_LANDING_PAGE,
  '': LEMONADE_PAGE, // home page
};
